import { render, staticRenderFns } from "./FacetGroups.vue?vue&type=template&id=d3e4f56c&scoped=true"
import script from "./FacetGroups.vue?vue&type=script&lang=js"
export * from "./FacetGroups.vue?vue&type=script&lang=js"
import style0 from "./FacetGroups.vue?vue&type=style&index=0&id=d3e4f56c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e4f56c",
  null
  
)

export default component.exports